'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Flex } from '@chakra-ui/react'

import { Button } from 'components/ui/Buttons/Button'
import { SectionCopy } from 'components/ui/Text/SectionCopy'
import { SectionHeading } from 'components/ui/Text/SectionHeading'
import { Container } from 'styles/shared'

import { ContactForm } from './components/ContactForm'

type Props = {
  isBackground?: boolean
  isContactPage?: boolean
}

export const ContactSection: React.FC<Props> = ({ isBackground = true, isContactPage = false }) => {
  const { t } = useTranslation('contact')

  return (
    <Box backgroundColor={isBackground ? 'green.a100' : 'transparent'} width="100%" padding={['28px 0', '80px 0']}>
      <Container>
        <Flex direction={['column', 'row']} justifyContent="space-between">
          <Box width={['100%', '40%']}>
            <SectionHeading>{t('contactHeading')}</SectionHeading>
          </Box>
          <Box width={['100%', '50%']}>
            <SectionCopy>{t('contactCopy')}</SectionCopy>
          </Box>
          <Box marginTop="36px" width="100%" display={{ base: isContactPage ? 'none' : 'block', md: 'none' }}>
            <Button href="/contact">{t('CTA')}</Button>
          </Box>
        </Flex>
        <Box display={{ base: isContactPage ? 'block' : 'none', md: 'block' }}>
          <ContactForm />
        </Box>
      </Container>
    </Box>
  )
}
